import React from 'react'
import { Pane, Display4, majorScale } from '@segment/react-ui-library'

const CardHeader = ({ title, children, ...props }) => (
  <Pane margin={majorScale(2)} display='flex' justifyContent='space-between' {...props}>
    <Display4>{title}</Display4>
    {children}
  </Pane>
)

export default CardHeader



// WEBPACK FOOTER //
// ./components/Customers/presentational/CardHeader.js